import React from 'react';
import MissingField from '../../@communityshare/ui/alerts/MissingField';

export default function OfferMissingField(props) {
  const { name } = props;

  return (
    <MissingField
      name={name}
      description={(
        <>
          Field must be provided before educator can connect with partners, or
          before the event will be shown to others.
        </>
      )}
    />
  );
}
